(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mega-menu"] && !Shopify.designMode) return;
  try {
    class MenuFeatureConfig extends HTMLElement {
    connectedCallback() {
      if (this.dataset.applied === 'true' || !this.querySelector('.menu-highlight-card')) return;

      this.querySelectorAll('.menu-highlight-card:nth-of-type(n + 3)').forEach((card) => card.remove());

      const headerMenu = this.closest('header-menu');
      if (!headerMenu) return;

      const targetUrl = this.normalizeUrl(this.dataset.menuItemUrl);
      const targetTitle = this.dataset.menuItemTitle || '';
      const submenus = Array.from(headerMenu.querySelectorAll('[data-menu-item-url]'));
      const submenu = submenus.find((item) => {
        if (targetUrl !== '') return this.normalizeUrl(item.dataset.menuItemUrl) === targetUrl;

        return targetTitle !== '' && item.dataset.menuItemTitle === targetTitle;
      });

      if (!submenu) return;

      const menu = submenu.querySelector('.mega-menu');
      const highlights = submenu.querySelector('.mega-menu__highlights');
      if (!menu || !highlights) return;

      menu.classList.remove('mega-menu--dropdown', 'mega-menu--columns');
      menu.classList.add('mega-menu--featured');
      submenu.classList.remove('menu-list__submenu--dropdown', 'menu-list__submenu--columns');
      submenu.classList.add('menu-list__submenu--featured');
      submenu.dataset.menuLayout = 'featured';
      this.dataset.applied = 'true';
      this.hidden = false;
      highlights.hidden = false;
      highlights.append(this);
    }

    normalizeUrl(url = '') {
      if (!url) return '';

      try {
        const pathname = new URL(url, window.location.origin).pathname;
        return pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
      } catch {
        return url;
      }
    }
  }

  if (!customElements.get('menu-feature-config')) {
    customElements.define('menu-feature-config', MenuFeatureConfig);
  }
  } catch(e) { console.error(e); }
})();

})();
